module.exports = __webpack_public_path__ + "static/media/viviane_ribeiro_de_siqueira.2a0037ae.png";